import {ConsentListener, ConsentProvider} from "./ProviderConstraintAndConsent";
import {createConsentMap, createConsentStorage, readStoredConsentMap, updateStoredConsent} from "./consentStorage";

const storage = createConsentStorage()

export class DefaultConsentProvider implements ConsentProvider {
  private _listeners: ConsentListener[] = [];
  private readonly _consentMap: Record<string, boolean|undefined> = createConsentMap()
  private readonly _useCookies: boolean = true;

  constructor(useCookies: boolean = true) {
    this._useCookies = useCookies;
    if(useCookies) {
      this._consentMap = readStoredConsentMap(storage)
    }
  }

  getConsent(provider: string): boolean {
    return this._consentMap[provider] || false
  }

  requestConsent(provider: string, consent: boolean): void {
    this.setConsent(provider, consent)
  }

  setConsent(provider: string, consent: boolean): void {
    this._consentMap[provider] = consent
    if(this._useCookies) {
      updateStoredConsent(storage, provider, consent)
    }
    this.fireConsentListener(provider, consent);
  }

  addConsentListener(listener: ConsentListener): void {
    this._listeners = [...this._listeners, listener];
  }

  removeConsentListener(listener: ConsentListener): void {
    this._listeners = this._listeners.filter(l => l !== listener)
  }

  protected fireConsentListener(provider: string, consent: boolean): void {
    this._listeners.forEach(value => value(provider, consent))
  }
}
